import { useEffect, useState } from 'react'
import { Button, scrollToId } from './primitives'

export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const check = () => {
      if (window.scrollY < 600) {
        setVisible(false)
        return
      }
      const pricing = document.getElementById('pricing')
      if (pricing) {
        const rect = pricing.getBoundingClientRect()
        const nearPricing = rect.top < window.innerHeight && rect.bottom > 0
        setVisible(!nearPricing)
        return
      }
      setVisible(true)
    }
    check()
    window.addEventListener('scroll', check, { passive: true })
    return () => window.removeEventListener('scroll', check)
  }, [])

  return (
    <div
      className={`sticky-mobile-cta${visible ? ' is-visible' : ''}`}
      style={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        right: 16,
        zIndex: 40,
        display: 'none',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(12px)',
        transition: 'opacity 200ms ease, transform 200ms ease',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <Button
        variant="accent"
        size="lg"
        onClick={() => scrollToId('pricing')}
        style={{
          width: '100%',
          justifyContent: 'center',
          boxShadow: '0 12px 28px -8px rgba(10,10,10,0.35)',
        }}
      >
        Start your site, $1,999 →
      </Button>
    </div>
  )
}
